<template>
  <tbody :class="className" v-bind="$attrs">
    <slot />
  </tbody>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  className?: Record<string, boolean> | string[] | string;
}>();

const { className } = toRefs(props);
</script>
